import { db } from "@/firebase/init.js";
import {
  collection,
  query,
  getDocs,
  getDoc,
  doc,
  deleteDoc,
  updateDoc,
  setDoc,
  orderBy,
} from "firebase/firestore"; // Create, Add Collection

const categoriesModule = {
  namespaced: true, // automatically added
  state: {
    categoriesList: [],
    category: {},
    contents: [],
    isLoading: true,
  },
  getters: {
    getCategories: (state) => state.categoriesList,
    getCategory: (state) => state.category,
    getParentCategories: (state) => state.categoriesList,
    isLoading: (state) => state.isLoading,
  },
  mutations: {
    setCategories: (state, payload) => {
      state.categoriesList = payload;
    },

    addCategory: (state, payload) => {
      if (state.categoriesList.length > 0)
        state.categoriesList.unshift(payload);
      else state.categoriesList = [payload];
    },

    deleteCategory: (state, payload) => {
      let filtered = state.categoriesList.filter(function (value) {
        return value.category_id != payload;
      });

      state.categoriesList = filtered;
    },

    updateCategory: (state, payload) => {
      const findIndex = state.categoriesList.findIndex(
        (category) => category.category_id == payload.category_id
      );
      state.categoriesList[findIndex] = payload;
    },

    setLoading: (state, payload) => {
      state.isLoading = payload;
    },
    // Get Category by id
    getReviewById: (state, payload) => {
      state.updateReview = state.categoriesList.find(
        (category) => category.category_id == payload
      );
    },
  },
  actions: {
    // Get All Categories
    async fetchCategories({ commit }) {
      commit("setLoading", true);
      const categoriesList = await getDocs(
        query(collection(db, "Categories"), orderBy("created_date", "desc"))
      );
      let categoriesArray = [];
      if (!categoriesList.empty) {
        categoriesList.forEach((doc) => {
          categoriesArray.push({ ...doc.data(), category_id: doc.id });
        });
      } else {
        console.log("No categories found");
        categoriesArray = false;
      }

      commit("setCategories", categoriesArray);
      commit("setLoading", false);
      return categoriesArray;
    },
    // Add Category
    async addCategory({ commit }, payload) {
      // const colRef = collection(db, "Categories");
      const documentReference = doc(collection(db, "Categories"));
      const category = {
        ...payload,
        category_id: documentReference.id,
        created_date: new Date(),
      };
      setDoc(documentReference, category);
      commit("addCategory", category);
    },
    // get Category by id
    async getCategoryByID({ commit }, payload) {
      let category = await getDoc(doc(db, "Categories", payload));
      commit("getReviewById", category.data());
      return category.data();
    },
    // Update Category
    async updateCategory({ commit }, payload) {
      updateDoc(doc(db, "Categories", payload.category_id), payload);
      commit("updateCategory", payload);
    },
    // Delete Category
    async deleteCategory({ commit }, payload) {
      deleteDoc(doc(db, "Categories", payload));
      commit("deleteCategory", payload);
    },
  },
};

export default categoriesModule;
